import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {ActivatedRoute, Params} from '@angular/router';
import {ClientsService} from '../../../../_services/clients.service';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {Subscription} from 'rxjs/Subscription';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';
import {Client} from '../../../../_interfaces/clients/clients';

@Component({
	selector: 'app-clients-building-maps-view',
	templateUrl: './clients-building-maps-view.component.html',
	styleUrls: ['./clients-building-maps-view.component.scss'],
	animations: [routeAnimation]
})

export class ClientsBuildingMapsViewComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public client_id: number = null;
	public building_map_id: number = null;
	public buildingMapImage: string = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];

	private _activatedRouteSubscription: Subscription = null;

	constructor(public clientsService: ClientsService,
				private activatedRoute: ActivatedRoute,
				private apiService: ApiService,
				private previousUrlService: PreviousUrlService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length === 0) {
				this.loadData();
			}
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.client_id = parseInt(params['client_id'], 10);
			this.building_map_id = parseInt(params['building_map_id'], 10);

			this.clientsService.getClient(this.client_id).then((client: Client) => {
				if (typeof client !== 'undefined') {
					this.pageTitleService.setTitle(client.company_name + ' | Plattegrond aanpassen | ' + environment.webappName);
					this.pageTitleService.setPageTitle(client.company_name);
				}
			});

			this.loadData();

			this.previousUrlService.setPreviousUrlIfNull('clients/' + this.client_id + '/view');
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}
	}

	loadData() {
		this.clientsService.getBuildingMap(this.client_id, this.building_map_id).then(building_map => {
			if (typeof building_map !== 'undefined') {
				this.buildingMapImage = building_map.map_url;

				this.dataLoaded = true;
			} else {
				this.missingData.push('Plattegrond');
			}
		});
	}
}
